import { AssetBrowser } from './AssetBrowser';

export default AssetBrowser;
